import React from 'react';
import { VideoModule as FMVideoModule } from '@spotify-internal/frodor-modules';
import { ModuleType } from '../types';
import { UnstyledLink } from '../../ui';
import { useT } from '../../../../features/src/i18n';

export type VideoModuleType = ModuleType & {
  supertext: string;
  headline: string;
  subtext?: string;
  useCustomCta?: boolean;
  ctaLink?: string;
  ctaText?: string;
  videoUrl: string;
  btnComponent?: React.FC;
};

export const VideoModule = React.forwardRef<
  React.MutableRefObject<ModuleType>,
  VideoModuleType
>((props, ref) => {
  const t = useT();
  const defaultCtaText = t(
    'FRODOR_VIDEO_MODULE_BACK_TO_VIDEOS',
    'Back to videos',
    'A link that when clicked will take the user back to All Videos',
  );
  const defaultCtaLink = '/videos';

  const LinkWithTracking: React.FC<any> = linkProps => {
    return (
      <UnstyledLink
        {...linkProps}
        track={[
          'module-video',
          `CTA Link - ${props.ctaText || defaultCtaText}`,
        ]}
      />
    );
  };

  return (
    <FMVideoModule
      {...props}
      ctaText={props.useCustomCta ? props.ctaLink : defaultCtaText}
      ctaLink={props.useCustomCta ? props.ctaText : defaultCtaLink}
      btnComponent={LinkWithTracking}
      ref={ref}
    />
  );
});
